import { ButtonList, DropdownButton } from '@dixa/lib-shared-habla';

export type ActionsMenuProps = {
  readonly onEditCredentials: () => void;
  readonly onDeleteKnowledgeBase: () => void;
};

export function KnowledgeBaseActionsMenu({
  onEditCredentials,
  onDeleteKnowledgeBase,
}: ActionsMenuProps): JSX.Element {
  return (
    <DropdownButton
      icon="dots-h"
      fixed
      buttonProps={{ variant: 'tertiary' }}
      noArrow
      dropdown={
        <ButtonList>
          <ButtonList.Item onClick={onEditCredentials}>
            Edit Knowledge
          </ButtonList.Item>
          <ButtonList.Divider />
          <ButtonList.Item onClick={onDeleteKnowledgeBase}>
            Delete Knowledge
          </ButtonList.Item>
        </ButtonList>
      }
    />
  );
}
